import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bluetooth': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M292.6 171.1L249.7 214 249.4 128 292.6 171.1M249.4 390.9L292.5 347.8 249.6 304.9 249.4 390.9zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zM257.5 259.4L336.9 170.8 211.8 36.5V213.4L138 139.6 111 166.5 203.7 259.5 111 352.5 137.9 379.4 211.7 305.6 214 475.6 341.4 348.1 257.5 259.4z'
      }
    ]
  }
})
